import api from './api';

// 사용자 관련 API 서비스
const userService = {
  // 사용자 프로필 조회
  async getProfile() {
    try {
      const response = await api.get('/user/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 잔액 조회
  async getBalance() {
    try {
      const response = await api.get('/user/balance');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 포인트 전환
  async convertPoints(amount) {
    try {
      const response = await api.post('/user/convert-points', { amount });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 베팅 내역 조회
  async getBettingHistory(params = {}) {
    try {
      const response = await api.get('/user/betting-history', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 입출금 내역 조회
  async getTransactionHistory(params = {}) {
    try {
      const response = await api.get('/user/transaction-history', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 출금 계좌 정보 등록/수정
  async updateBankAccount(bankInfo) {
    try {
      const response = await api.put('/user/bank-account', bankInfo);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 출금신청 생성
  async createWithdrawalInquiry(data) {
    try {
      const response = await api.post('/withdrawal/inquiry', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // [2026-11-03] 코인출금 화면 안내(환율·네트워크·회원 지갑)
  async getCoinWithdrawalSettings() {
    try {
      const response = await api.get('/withdrawal/crypto-settings');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 출금신청 내역 조회
  async getWithdrawalHistory(params = {}) {
    try {
      const response = await api.get('/withdrawal/inquiry-history', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 출금 쿨다운 설정 조회
  async getWithdrawalCooldownSettings() {
    try {
      const response = await api.get('/user/withdrawal-cooldown-settings');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 출금 롤링 조건 설정 조회
  async getWithdrawalRollingCondition() {
    try {
      const response = await api.get('/system-settings/withdrawal-rolling');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default userService;